/* eslint-disable react-hooks/exhaustive-deps */
import { EditOutlined, DeleteOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Popconfirm } from "antd";
import { ColumnsType } from "antd/lib/table";
import { IDonationSponsor } from "interfaces/IDonationSponsor";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";

import { Table } from "antd";

export interface FieldError {
  name: any;
  errors: string[];
  warnings: string[];
}

const InputControlled = React.forwardRef<any, { defaultValue: string, onNotValid?: (noValid: boolean) => void }>((props, ref) => {
  const [value, setValue] = useState("")
  const [noValid, setNoValid] = useState(false)
  useEffect(() => {
    setValue(props?.defaultValue)
  }, [props.defaultValue])

  const onChange = (e) => {
    let inputValue = e.target.value
    if (inputValue.trim() === '') {
      inputValue = ""
    }

    setValue(inputValue)
  }

  useEffect(() => {
    if (props?.onNotValid) {
      if (value.length < 1) {
        if (!noValid)
          props?.onNotValid(true)
        setNoValid(true)
      }
      else if (value.length > 0 && noValid) {
        props?.onNotValid(false)
        setNoValid(false)
      }
    }
  }, [value])

  return <Form.Item
    validateStatus={(!value) ? "error" : undefined}
    hasFeedback
    // help={(!value) && "this field is required"}
    style={{ margin: 0 }}

  > <Input ref={ref} value={value} onChange={onChange} defaultValue={props?.defaultValue} />
  </Form.Item>
})

interface DonationSponsorEditTableProps {
  data: any[],
  hasDefault?: boolean,
  invalid?: FieldError[],
  value?: string,
  onChange?: (value: any[]) => void
  onDelete?: (uuid: string) => void
  loading?: boolean
  onEditing?: (isEditing: boolean) => void
}

const DonationSponsorEditTable = React.forwardRef<any, DonationSponsorEditTableProps>((props, ref) => {
  const [isEditing, setIsEditing] = useState<number | null>(null)
  const [value, setValue] = useState<any[]>([])
  const inputDescriptionRef = useRef<InstanceType<typeof Input>>(null)
  const inputAmountRef = useRef<HTMLInputElement>(null)
  const [isInputInvalid, setIsInputInvalid] = useState(false)

  useImperativeHandle(ref, () => ({
    reset: () => {
      setIsEditing(null)
    },
    add: ()=> { 
      handleNew()
    }
  }))

  useEffect(() => {
    props.onEditing && props.onEditing(!!isEditing) 
  },[isEditing])

  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  useEffect(() => {
    if (arraysAreEqual(props.data, covertObjectoArray(value, ["uuid", "description", "amount"]))) {
      props?.onChange && props.onChange([])
    } else {
      if (!props?.hasDefault) {


        const valuesChanged = covertObjectoArray(value, ["uuid", "description", "amount"])
          .filter((newData, i) => {
            if (props.data[i]?.currentIndex  === undefined && newData.description  &&  newData.amount ) {
              return newData
            }
            if ((newData?.currentIndex === props.data[i]?.currentIndex )&& (newData.description !== props.data[i].description || newData.amount !== props.data[i].amount)) {
              return newData
            }
            return null
          })

        props?.onChange && props.onChange(valuesChanged)


      }
      else {
        props?.onChange && props.onChange(covertObjectoArray(value, ["uuid", "description", "amount"]))
      }
    }

  }, [value])

  useEffect(() => {
    if (props?.data) {
      setValue(covertArrayToObject(props.data, ["uuid", "description", "amount"]))
    }
  }, [props?.data])


  function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (!objectsAreEqual(arr1[i], arr2[i])) {
        return false;
      }
    }

    return true;
  }

  function objectsAreEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }


  const covertArrayToObject = (array: any[], keys: string[]) => {
    const obj: any = {}
    const converted = array.reduce((prv, cc, i) => {
      keys.forEach(k => {
        if (Object.keys(cc).includes(k)) {
          obj[`${k}-${i}`] = cc[k];
        }
      })
      return obj
    }, {} as any)

    return converted
  }


  const covertObjectoArray = (obj, keys: string[]) => {
    const converted = Object.keys(obj).reduce((acc: any[], key) => {
      const [prop, index] = key.split("-");
      const currentIndex = parseInt(index);

      if (!acc[currentIndex]) {
        acc[currentIndex] = { currentIndex };
      }
      keys.forEach(k => {
        if (k === prop) {
          acc[currentIndex][k] = obj[key];
        }
      })
      return acc
    }, []);

    return converted

  }

  const handleChange = (index, record) => {
    let updatedDescriptionValue: Record<string, string> = {};
    let updatedAmountValue: Record<string, string> = {};

    if (inputDescriptionRef?.current && inputDescriptionRef?.current.state.value) {
      updatedDescriptionValue = { [`description-${index}`]: inputDescriptionRef?.current.state.value }
    }
    if (inputAmountRef?.current && inputAmountRef?.current.value.replace(/\$\s?|(,*)/g, '').trim()) {
      updatedAmountValue = { [`amount-${index}`]: inputAmountRef?.current.value.replace(/\$\s?|(,*)/g, '') || "0" }
    }

    setValue(values => ({ ...values, ...updatedDescriptionValue, ...updatedAmountValue }))

  }


  const handleNew = () => {
    const index = covertObjectoArray(value, ["uuid", "description", "amount"]).length
    setIsEditing(index)
    
    let newDescriptionValue: Record<string, string> = {};
    let updatedAmountValue: Record<string, string> = {};

    newDescriptionValue = { [`description-${index}`]: "" }
    updatedAmountValue = { [`amount-${index}`]: "0" }

    setValue(values => ({ ...values, ...newDescriptionValue, ...updatedAmountValue }))
   

  }


  const handleRemove = (index) => {
    const updatedList = covertArrayToObject(covertObjectoArray(value, ["uuid", "description", "amount"])
      .filter(value => value.currentIndex !== index), ["uuid", "description", "amount"])

    setValue({ ...updatedList })
  }



  const cols: ColumnsType<IDonationSponsor & { currentIndex: number }> = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (item, record) => {
        return <>
          <Form.Item
            hidden noStyle >
            <Input />
          </Form.Item>

          {isEditing === record?.currentIndex ? <InputControlled ref={inputDescriptionRef} onNotValid={setIsInputInvalid} defaultValue={item} /> : item}

        </>
      }
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 200,
      key: "amount",
      render: (item: IDonationSponsor["amount"], record) => {
        return <>
          <Form.Item
            noStyle
          >
            {isEditing === record.currentIndex ? <InputNumber
              min={0}
              ref={inputAmountRef}
              defaultValue={item}
              className="input-donation-value"
              formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value: any) => value.replace(/\s+/g, ' ').replace(/\$\s?|(,*)/g, '')}
            /> : item && USDollar.format(Number(item)).replace(/^(\D+)/, '$1 ')}
          </Form.Item>
        </>
      }
    },
    {
      title: "",
      width: 150,
      key: "action",
      render: (_, record) => {

        return <div className="donations-sponsor-table-action">
          {isEditing === record.currentIndex
            ? <Button disabled={isInputInvalid} type="dashed" shape="round" onClick={() => {
              handleChange(record.currentIndex, record)
              setIsEditing(null)
            }} icon={<CheckOutlined />} />
            : <Button type="dashed" shape="round" onClick={() => {
              setIsEditing(record.currentIndex)
              }} icon={<EditOutlined />} />}

          {!props.hasDefault && <Popconfirm
            title="Are you sure about deleting this item?"
            placement="topLeft"
            onConfirm={() => {
              if (record?.uuid && props.onDelete) {
                props.onDelete(record.uuid)
                return
              }
              handleRemove(record.currentIndex)

            }}
          >
            <Button type="dashed" shape="round" icon={<DeleteOutlined />} />
          </Popconfirm>}
        </div>
      }
    }
  ]
  return <Table
    bordered
    title={props.hasDefault ? () => <span>The following values are set as default</span> : undefined}
    loading={props.loading}
    columns={cols}
    dataSource={covertObjectoArray(value, ["uuid", "description", "amount"]) || []}
    pagination={false}
  />

})

export { DonationSponsorEditTable };